/*!
 * CARRITO QURANI V1 · assets/qt-cart-incentive.js
 * Regalo automático real + timer propio del carrito lateral (y de /cart). Sin apps ni dependencias.
 * Se administra en: Personalizar → Configuración del tema → Carrito Qurani.
 *
 * REGALOS V2 (oct-2026): dos reglas, máximo UN regalo por carrito.
 * - Regla 1 (Detox): hay al menos un producto SIN la etiqueta de velas y el elegible llega a minCents.
 * - Regla 2 (Tarjeta): todos los productos llevan la etiqueta de velas y el elegible llega a minCents2.
 * - Si cambia el tipo de carrito se reemplaza el regalo; si deja de calificar se quita.
 *
 * Reglas:
 * - El regalo es una línea REAL del carrito con propiedades internas _Regalo y _Campaña.
 *   Solo se agregan/quitan líneas con _Regalo: un producto comprado (aunque sea el mismo Detox) nunca se toca.
 * - El subtotal elegible lo calcula Liquid (colección elegible, SIN la línea regalo) en [data-qt-state].
 * - Se agrega solo con el carrito a la vista; se quita en cualquier momento (baja del mínimo, vence, OFF).
 * - Shopify aplica el regalo a la primera línea de esa variante: si un Detox comprado queda antes,
 *   el regalo se re-agrega para quedar primero (así el descuento siempre cae en la línea regalo).
 * - Timer: vencimiento real por Campaign ID en localStorage. Al llegar a 00:00 esa campaña queda
 *   vencida en ese navegador (refresh/cambio de página no la reinicia). Nueva campaña = nuevo Campaign ID.
 */
(function () {
  'use strict';
  if (window.qtCartIncentive) return;
  var cfgEl = document.getElementById('qt-cart-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* En /cart este snippet vive dentro de la lista de productos (el tema la reemplaza): el CSS pasa a <head>. */
  var css = document.querySelector('link[data-qt-css]');
  if (css && css.parentNode !== document.head) document.head.appendChild(css);

  var S = window.Shopify || {};
  var ROOT = (S.routes && S.routes.root) || '/';
  var PROP = '_Regalo';
  var PROP_VAL = 'Carrito Qurani';
  var PROP_CAMP = '_Campaña';
  var LIVE = !!(S.theme && S.theme.role === 'main') && !S.designMode;
  var CAMPAIGN = String(C.campaign || 'qt-default');
  var DUR = Math.max(1, parseInt(C.minutes, 10) || 15) * 60000;
  var K_TIMER = 'qt_cart_timer:' + CAMPAIGN;
  var K_BLOCK = 'qt_cart_block:' + CAMPAIGN;
  var K_RELOAD = 'qt_cart_reload';
  var ON_CART_PAGE = !!document.querySelector('[data-cart-page]');
  var EMPTY = { elig: 0, hasElig: false, candle: false, nonCandle: false, giftFree: false, lines: [] };

  /* ---------- almacenamiento (si el navegador lo bloquea, funciona en memoria) ---------- */
  var mem = {};
  function lget(k) { try { var v = window.localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return mem[k] || null; } }
  function lset(k, v) { mem[k] = v; try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return mem['s:' + k] || null; } }
  function sset(k, v) { mem['s:' + k] = v; try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function warn(m) { if (window.console) console.warn('[Carrito Qurani] ' + m); }
  function each(sel, fn) { var l = document.querySelectorAll(sel); for (var i = 0; i < l.length; i++) fn(l[i]); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- tema Palo Alto: window.cart = CartDrawer (solo fuera de /cart) ---------- */
  function drawer() { var t = window.cart; return t && typeof t.getCart === 'function' && document.getElementById('cart-drawer') ? t : null; }
  function visible() { if (ON_CART_PAGE) return true; var t = drawer(); return !!(t && t.isCartDrawerOpen); }
  /* Bloquea el carrito mientras se agrega/quita el regalo (evita clics sobre índices de línea viejos).
     Solo se desbloquea lo que este script bloqueó; el re-render del tema (getCart) también lo libera. */
  var locked = false;
  function lock(on) {
    var t = drawer();
    if (!t) return;
    try {
      if (on && !locked && t.isCartDrawerOpen) { t.disableCartButtons(); t.addLoadingClass(); locked = true; }
      else if (!on && locked) { t.enableCartButtons(); t.removeLoadingClass(); locked = false; }
    } catch (e) {}
  }

  /* ---------- estado del carrito ---------- */
  function parse(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function domState() {
    var el = null;
    each('[data-items-holder]', function (h) { el = h.querySelector('[data-qt-state]') || el; });
    if (!el) {
      var tpl = document.querySelector('[data-cart-drawer-template]');
      if (tpl && tpl.content) el = tpl.content.querySelector('[data-qt-state]');
    }
    return parse(el) || EMPTY;
  }
  function fetchState() {
    return fetch(ROOT + 'cart?section_id=api-cart-items', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('estado HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return parse(doc.querySelector('[data-qt-state]')) || EMPTY;
      });
  }
  function giftsOf(st) {
    var out = [];
    (st.lines || []).forEach(function (l, i) { if (l.g) out.push({ k: l.k, v: +l.v, q: +l.q, c: l.c || '', pos: i + 1 }); });
    return out;
  }

  /* ---------- timer ---------- */
  function rec() { return lget(K_TIMER); }
  function expired() { if (!C.timer) return false; var r = rec(); return !!(r && (r.expired || (r.exp && Date.now() >= r.exp))); }
  function ensureTimer() { if (C.timer && !rec()) lset(K_TIMER, { exp: Date.now() + DUR }); }
  function blocked() { return LIVE && sget(K_BLOCK) === '1'; }

  /* ---------- decisión ---------- */
  /* Qué regalo corresponde a este carrito (variante) o 0 si ninguno. */
  function target(st) {
    if (!C.gift || !st.hasElig || expired() || blocked()) return 0;
    var tagSet = !!C.tagSet;
    if ((!tagSet || st.nonCandle) && C.variantId && C.available && st.elig >= C.minCents) return +C.variantId;
    if (C.gift2 && tagSet && st.candle && !st.nonCandle && C.variantId2 && C.available2 && st.elig >= C.minCents2) return +C.variantId2;
    return 0;
  }
  function plan(st) {
    var g = giftsOf(st);
    var tv = target(st);
    var want = !!tv;
    if (g.length) {
      var keys = g.map(function (x) { return x.k; });
      if (!want) return { type: 'remove', keys: keys };
      var first = g[0];
      if (first.v !== tv || first.c !== CAMPAIGN) return { type: 'replace', keys: keys, v: tv };
      if (g.length > 1 || first.q !== 1) return { type: 'normalize', keep: first.k, keys: keys.slice(1) };
      var lines = st.lines || [];
      for (var i = 0; i < first.pos - 1; i++) {
        if (!lines[i].g && +lines[i].v === tv) return { type: 'reposition', keys: [first.k], v: tv };
      }
      if (LIVE && !st.giftFree) return { type: 'notfree', keys: [first.k] };
      return { type: 'ok' };
    }
    return want ? { type: 'add', v: tv } : { type: 'none' };
  }

  /* ---------- llamadas al carrito (Cart AJAX API) ---------- */
  function post(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(path + ' HTTP ' + r.status); return r.json(); });
  }
  function setQty(map) { return post('cart/update.js', { updates: map }); }
  function removeKeys(keys) { var u = {}; keys.forEach(function (k) { u[k] = 0; }); return setQty(u); }
  function addGift(v) {
    if (!v) return Promise.resolve(null);
    ensureTimer();
    var props = {};
    props[PROP] = PROP_VAL;
    props[PROP_CAMP] = CAMPAIGN;
    return post('cart/add.js', { items: [{ id: +v, quantity: 1, properties: props }] });
  }

  /* ---------- ciclo ---------- */
  var last = EMPTY, busy = false, again = false, againFresh = false, dirty = false, halted = false, noAdd = false, hist = [], flashUntil = 0, timerId = null, safety = null, lastChange = 0;

  /* freno anti-bucle: si algo externo deshiciera el regalo una y otra vez, se detiene en esta página */
  function guard() {
    var now = Date.now();
    hist = hist.filter(function (t) { return now - t < 15000; });
    hist.push(now);
    if (hist.length > 8) { halted = true; lock(false); warn('demasiados cambios seguidos: se detiene en esta página.'); }
    return !halted;
  }

  function refresh() {
    if (ON_CART_PAGE) {
      var r = lget(K_RELOAD) || { n: 0, t: 0 }, now = Date.now();
      if (now - r.t > 30000) r = { n: 0, t: now };
      if (r.n >= 3) { warn('recargas repetidas en /cart: se detiene.'); return; }
      r.n++;
      lset(K_RELOAD, r);
      window.location.reload();
      return;
    }
    var t = drawer();
    if (t && t.isCartDrawerOpen) {
      locked = false;
      t.getCart();
      /* si el re-render del tema fallara (red), el carrito no queda bloqueado */
      clearTimeout(safety);
      safety = setTimeout(function () { try { t.enableCartButtons(); t.removeLoadingClass(); } catch (e) {} }, 6000);
      return;
    }
    lock(false);
    dirty = true;
  }

  function run(fresh) {
    if (halted) return;
    if (busy) { again = true; againFresh = againFresh || !!fresh; return; }
    busy = true;
    var action = null;
    /* justo después de un cambio propio se decide con el carrito real del servidor, no con el HTML */
    if (Date.now() - lastChange < 4000) fresh = true;
    (fresh ? fetchState() : Promise.resolve(domState())).then(function (st) {
      last = st;
      decorate();
      var a = plan(st), vis = visible();
      action = a;
      if (a.type === 'ok') { ensureTimer(); return false; }
      if (a.type === 'none') return false;
      if ((a.type === 'add' || a.type === 'reposition') && (!vis || noAdd)) return false;
      if (!guard()) return false;
      lock(true);
      switch (a.type) {
        case 'add': return addGift(a.v).then(function () { return true; });
        case 'reposition': return removeKeys(a.keys).then(function () { return addGift(a.v); }).then(function () { return true; });
        case 'replace': return removeKeys(a.keys).then(function () { return vis && !noAdd ? addGift(a.v) : null; }).then(function () { return true; });
        case 'normalize': var u = {}; u[a.keep] = 1; a.keys.forEach(function (k) { u[k] = 0; }); return setQty(u).then(function () { return true; });
        case 'notfree':
          sset(K_BLOCK, '1');
          warn('el regalo no quedó en S/ 0 (descuento automático del regalo inactivo o un cupón incompatible): se retiró y no se reintenta en esta sesión.');
          return removeKeys(a.keys).then(function () { return true; });
        default: return removeKeys(a.keys).then(function () { return true; });
      }
    }).then(function (changed) {
      busy = false;
      if (changed) {
        lastChange = Date.now();
        /* el re-render del tema (o la próxima apertura / recarga) vuelve a evaluar: no se encadena otra corrida */
        again = false; againFresh = false;
        refresh();
        return;
      }
      lock(false);
      if (again) { var f = againFresh; again = false; againFresh = false; run(f); }
    }).catch(function (err) {
      busy = false;
      lock(false);
      if (action && (action.type === 'add' || action.type === 'reposition' || action.type === 'replace')) noAdd = true;
      warn(err && err.message ? err.message : String(err));
      if (action && action.type !== 'none' && action.type !== 'ok') { lastChange = Date.now(); again = false; refresh(); }
    });
  }

  var sched = null;
  function schedule(fresh, ms) {
    clearTimeout(sched);
    sched = setTimeout(function () { run(fresh); }, typeof ms === 'number' ? ms : 60);
  }

  /* ---------- UI: aviso, nota de vista previa y franja del timer ---------- */
  function decorate() {
    var teaser = !!(C.gift && !expired() && !blocked());
    each('[data-qt-teaser]', function (el) { el.hidden = !teaser; });
    each('[data-qt-preview-note]', function (el) { el.hidden = LIVE; });
    renderTimer();
  }

  function renderTimer() {
    var now = Date.now(), show = false, isExp = false, text = C.timerText || '', clock = '';
    if (flashUntil > now) {
      show = true; isExp = true; text = C.expiredText || '';
    } else if (C.gift && C.timer && giftsOf(last).length) {
      var r = rec();
      if (r && !r.expired && r.exp > now) {
        var s = Math.max(0, Math.ceil((r.exp - now) / 1000));
        clock = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
        show = true;
      }
    }
    each('[data-qt-timer]', function (el) {
      if (el.hidden === show) el.hidden = !show;
      el.classList.toggle('is-expired', isExp);
      var t = el.querySelector('[data-qt-timer-text]'), c = el.querySelector('[data-qt-timer-clock]');
      if (t && t.textContent !== text) t.textContent = text;
      if (c && c.textContent !== clock) c.textContent = clock;
    });
  }

  function tick() {
    if (C.timer) {
      var r = rec();
      if (r && !r.expired && r.exp && Date.now() >= r.exp) {
        r.expired = true;
        lset(K_TIMER, r);
        if (giftsOf(last).length) flashUntil = Date.now() + 7000;
        schedule(true, 0);
      }
    }
    renderTimer();
  }

  /* ---------- eventos del tema ---------- */
  document.addEventListener('theme:cart:added', function () { clearTimeout(safety); dirty = false; locked = false; last = domState(); decorate(); schedule(false); });
  document.addEventListener('theme:cart:loaded', decorate);
  document.addEventListener('theme:cart:open', function () {
    decorate();
    if (dirty) {
      dirty = false;
      setTimeout(function () { var t = drawer(); if (t && t.isCartDrawerOpen) t.getCart(); else schedule(true); }, 0);
      return;
    }
    schedule(false);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { dirty = true; schedule(true); } });

  function init() {
    last = domState();
    decorate();
    schedule(false, 0);
    if (C.gift && C.timer && !timerId) timerId = setInterval(tick, 1000);
  }

  window.qtCartIncentive = {
    config: C,
    state: function () { return last; },
    target: function () { return target(last); },
    timer: function () { return rec(); },
    resetTimer: function () { try { window.localStorage.removeItem(K_TIMER); window.sessionStorage.removeItem(K_BLOCK); } catch (e) {} delete mem[K_TIMER]; delete mem['s:' + K_BLOCK]; },
    run: function () { schedule(true, 0); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  } else {
    setTimeout(init, 0);
  }
})();
